export const Member = {
    id: '',
    email: '',
    password: '',
    fullName: '',
    role: false,
    phoneNumber:'',
    status: false,
    isDeleted: false
}

